import { Avatar } from 'src/design-system'
import { avatarProps } from 'app/packs/src/utils/user-helpers'
import { observer } from 'mobx-react-lite'
import * as React from 'react'
import { store } from 'store/index'
import { UserWithProficiency } from '../table/data'

type UserRowProps = {
  userWithProficiency: UserWithProficiency
}

export const UserRow: React.FC<UserRowProps> = observer(
  ({ userWithProficiency }) => {
    const user = store.users.byId(userWithProficiency.userId)

    if (!user) return null

    const isInferred = userWithProficiency.source === 'implied'

    return (
      <div className="flex items-center gap-3 py-1 mb-1">
        <Avatar className="w-10 h-10" {...avatarProps(user)} />
        <div className="flex flex-col flex-1 min-w-0">
          <p className="font-medium text-sm text-gray-900 mb-0 truncate">
            {user.fullName}
          </p>
          <p className="text-xs text-gray-600 mb-0 truncate">
            {user.position?.name}
          </p>
        </div>
        {isInferred && (
          <span className="inline-flex items-center h-[20px] text-xs text-orange-700 bg-orange-100 px-2 py-0.5 rounded">
            Inferred
          </span>
        )}
      </div>
    )
  }
)
